import { Navigate, Outlet } from "react-router-dom";
import { LoginInfo } from "@/services/login-service/entities/LoginEntity.ts";
import { AuthenticationFunctions } from "@/commons/AuthenticationFunctions.ts";

export const PublicRoute = () => {
  const loginInfo: LoginInfo = new LoginInfo(
    JSON.parse(localStorage.getItem("LOGIN_INFO") || "{}"),
  );
  let workingTenant = "root";
  if (loginInfo) {
    const tenant = AuthenticationFunctions.getTokenDataByKey("tenantId");
    if (tenant) {
      workingTenant = tenant;
    }
  }
  return loginInfo && loginInfo.accessToken ? (
    <Navigate to={`/${workingTenant}/tenants`} replace />
  ) : (
    <Outlet />
  );
};
